import React from 'react';
import { SFEntityID, OfficeHours } from 'utils/types';
import PropTypes from 'prop-types';
import css from './WalkInSection.scss';
import Title from '../../common/Title';
import { getWord } from 'utils/tenant';

const WalkInItem = ({title, hoursText}) => {
  return (
    <div className={css['walk-in-item']}>
      <span className={css['hours-title']}>{title}: </span> {hoursText}
    </div>
  );
};

const rowsToDisplay = 4;

export default class WalkInSection extends React.Component {

  constructor() {
    super();
    this.state = { showMoreOfficeHours: false }
  }

  toggleDisplayLimit() {
    this.setState({ showMoreOfficeHours: !this.state.showMoreOfficeHours })
  }

  get displayLimitButton() {
    if (this.props.walkInOfficeHours.length <= rowsToDisplay) return null;
    return <span className={css['walk-in-show-toggle']} onClick={this.toggleDisplayLimit.bind(this)}>
      View {this.state.showMoreOfficeHours ? "Less" : "More"}</span>
  }

  get numItemsToLimit() {
    if (this.props.walkInOfficeHours.length <= rowsToDisplay) return this.props.walkInOfficeHours.length;
    else return rowsToDisplay - 1;
  }

  render() {
    return (
      <div className={css['walk-in-container']}>
        <Title text={`This Week's ${getWord('dropIn', false)} Hours`} />
        {this.props.walkInOfficeHours
          .slice(0, this.state.showMoreOfficeHours ? this.props.walkInOfficeHours.length : this.numItemsToLimit)
          .map((hour, i) => <WalkInItem key={i} {...hour} />)}
        {this.displayLimitButton}
      </div>
    );
  }
}

WalkInSection.propTypes = {
  personId: SFEntityID.isRequired,
  walkInOfficeHours: OfficeHours
};

WalkInItem.propTypes = {
  title: PropTypes.string.isRequired,
  hoursText: PropTypes.string.isRequired
};
